export default __webpack_public_path__ + "static/media/google-icon-square-rounded.5f8c4c63.svg";